import React from 'react';
import { IconProps } from '.';

const SvgColoredGraphUp = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#C8EBD3'
        d='M1.333 4A2.667 2.667 0 0 1 4 1.333h16A2.667 2.667 0 0 1 22.666 4v16A2.667 2.667 0 0 1 20 22.667H4A2.667 2.667 0 0 1 1.333 20V4Z'
      />
      <path
        fill='#23AE50'
        fillRule='evenodd'
        d='M20.417 3.984a.8.8 0 0 1 .266 1.1l-7.334 12a.8.8 0 0 1-1.29.103L8.762 13.34l-4.087 6.423a.8.8 0 1 1-1.35-.86l4.667-7.333a.8.8 0 0 1 1.282-.09l3.284 3.83 6.76-11.06a.8.8 0 0 1 1.1-.266Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgColoredGraphUp;
